import {ElementRef, NgZone} from '@angular/core';

export class AutoLoadTriggerObserver {
  private observer?: IntersectionObserver;
  private triggerElement?: HTMLElement;

  constructor(
    private readonly ngZone: NgZone,
    private readonly onTrigger: () => void) { }

  observe(element: ElementRef<HTMLElement> | undefined): void {
    this.observer?.disconnect();

    const trigger = element?.nativeElement;
    this.triggerElement = trigger;
    if (!trigger) {
      return;
    }

    const ionContent = trigger.closest('ion-content') as HTMLElement & { getScrollElement?: () => Promise<HTMLElement> };

    if (!ionContent?.getScrollElement || typeof IntersectionObserver === 'undefined') {
      return;
    }

    ionContent.getScrollElement().then((scrollElement: HTMLElement) => {
      if (this.triggerElement !== trigger) {
        return;
      }

      this.ngZone.runOutsideAngular(() => {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.ngZone.run(() => this.onTrigger());
          }
        }, {
          root: scrollElement,
          rootMargin: '0px 0px 320px 0px'
        });

        this.observer.observe(trigger);
      });
    });
  }

  disconnect(): void {
    this.observer?.disconnect();
  }
}
